// extracted by mini-css-extract-plugin
export default {"form_container":"entrance-form_form_container__72MDR"};